export const SET_PLUGINS_LIST = 'SET_PLUGINS_LIST'



// WEBPACK FOOTER //
// ./src/types/plugins.js